import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LibraryPanesModule } from '@app/library/panes/library-panes.module';
import { SchoolFormModule } from '@app/school-settings/school-form/school-form.module';
import { SchoolCardComponent } from '@app/schools/school-card/school-card.component';
import { SchoolPageModule } from '@app/schools/school-page/school-page.module';
import { AlertModule } from '@core/components/alert/alert.module';
import { BookmarkComponent } from '@core/components/bookmark/bookmark.component';
import { MobileModalModule } from '@core/components/mobile-modal/mobile-modal.module';
import { ModalModule } from '@core/components/modal/modal.module';
import { CoreModule } from '@core/core.module';
import { PipesModule } from '@core/pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '@shared/icon/icon.component';
import { RatingComponent } from '@shared/rating/rating.component';
import { ClipboardModule } from 'ngx-clipboard';
import { OnUiButtonModule, OnUiCardMenuModule, OnUiCoverModule } from 'onclass-ui';

@NgModule({
  declarations: [SchoolCardComponent],
  exports: [SchoolCardComponent],
  imports: [
    AlertModule,
    BookmarkComponent,
    ClipboardModule,
    CommonModule,
    CoreModule,
    LibraryPanesModule,
    MobileModalModule,
    ModalModule,
    OnUiButtonModule,
    OnUiCardMenuModule,
    OnUiCoverModule,
    RouterModule,
    SchoolFormModule,
    SchoolPageModule,
    TranslateModule,
    PipesModule,
    RatingComponent,
    IconComponent,
  ],
})
export class SchoolCardModule {}
